import type { ReportEvent } from '@/types/report';

function includesInsensitive(haystack: string, needle: string): boolean {
    return haystack.toLowerCase().includes(needle);
}

function matchesSearch(event: ReportEvent, needle: string): boolean {
    return (
        includesInsensitive(event.promptText, needle) ||
        includesInsensitive(event.sourceName, needle)
    );
}

export function filterReportEvents(
    events: ReportEvent[],
    search: string,
): ReportEvent[] {
    const trimmed = search.trim().toLowerCase();
    if (trimmed.length === 0) {
        return events;
    }
    return events.filter((event) => matchesSearch(event, trimmed));
}
